import Logo from "@/assets/img/sublogoPRed.png";

import {
  SidebarHeader,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from "../ui/sidebar";
import {
  Wallet,
  WalletTitle,
  WalletBalance,
  WalletRechargeButton,
} from "../wallet";
import { CompanyRating } from "./components/company-rating";

export function AppSidebarHeader() {
  return (
    <SidebarHeader className="bg-background">
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton size="lg" asChild className="pointer-events-none">
            <a href="#">
              <div className="flex aspect-square size-10 items-center justify-center rounded-lg bg-black text-sidebar-primary-foreground dark:bg-transparent">
                <img src={Logo} alt="Logo" className="h-6 w-6" />
              </div>
            </a>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>

      <CompanyRating />

      <Wallet>
        <WalletTitle>Saldo</WalletTitle>
        <WalletBalance />
        <WalletRechargeButton />
      </Wallet>
    </SidebarHeader>
  );
}
